import React from 'react';
// import { Link } from 'react-router-dom';
import {PostContactUs} from '../../../components/ContactForm/formAction';

// import useAnalyticsEventTracker from '../../../services/useAnalyticsEventTracker';
import { businessLogic } from '../../../lib/constants';
import { useTranslation } from "react-i18next";
import { FiMapPin, FiMail } from 'react-icons/fi';



const ContactArea = () => {
  const { t } = useTranslation();

   // const gaEventTracker = useAnalyticsEventTracker('Contact us');


   return (
      <>
         <section className="contact__area" id='contact'>
            <div className="container-fluid p-0">
               <div className="row g-0">
                  <div className="col-xl-12">
                     <div className="contact__map">
                        {/* <iframe title='contact' src="https://maps.google.com/maps?hl=en&amp;q=Dhaka+()&amp;ie=UTF8&amp;t=&amp;z=10&amp;iwloc=B&amp;output=embed"></iframe> */}
                        <div className="contact__wrapper d-md-flex justify-content-between wow fadeInUp" data-wow-delay=".3s">
                           <div className="contact__info mr-100">
                              <span className="contact__kicker">{t("home_contact_area_title_mini")}</span>
                              <h3>{t("home_contact_title")}</h3>
                              <p className="contact__lead">{t("home_contact_area_title_big")}</p>
                              <ul>

                                 <li>
                                    <div className="contact__info-item">
                                       <span className="contact__info-icon">
                                          <FiMapPin />
                                       </span>
                                       <div>
                                          <h4>{t("home_contact_address")}</h4>
                                          <p>{businessLogic.address}</p>
                                       </div>
                                    </div>
                                 </li>

                                 {/* <li>
                                    <h4>call us</h4>
                                    <p><a href={`${businessLogic.phoneNumber}`}>{businessLogic.phoneNumber}</a></p>
                                 </li> */}
                                 {/* <Link to="" className="z-btn z-btn-transparent mt-10" style={{ backgroundColor: '#25D366' }} onClick={()=>gaEventTracker('WhatsApp-ContactArea')}>WhatsApp</Link> */}


                                 <li>
                                    <div className="contact__info-item">
                                       <span className="contact__info-icon">
                                          <FiMail />
                                       </span>
                                       <div>
                                          <h4>{t("home_contact_email")}</h4>
                                          {/* <p><a href={`mailto:${businessLogic.emailBase}`} onClick={()=>gaEventTracker('email')}>{businessLogic.emailBase}</a></p> */}
                                          <p><a href={`mailto:${businessLogic.emailBase}`}>{businessLogic.emailBase}</a></p>
                                       </div>
                                    </div>
                                 </li>

                                 {/* <li>
                                    <h4>WhatsApp</h4>
                                    // <div onClick={()=>gaEventTracker('WhatsApp-HomePage')}>
                                    <div>
                                       <Link to="" className="z-btn z-btn-transparent mt-10" style={{ backgroundColor: '#25D366' }} >WhatsApp</Link>
                                    </div>
                                 </li> */}
                                 

                                 
                              </ul>
                           </div>
                           
                           <PostContactUs
                              gridProps={{
                                  meshProps: {
                                    color: "#6a60f0",
                                    opacity: 0.05,
                                    amp: 0.035,
                                    freq: 0.9,
                                    rotation: [0, 0, 0],
                                    position: [0, 0, 0],
                                    planeArgs: [10, 10, 180, 180],
                                 },
                                 camera: { position: [0, 0, 6.2], fov: 55 },
                                 dpr: [1, 1.4],
                              }}
                              gradient="linear-gradient(135deg, rgba(124, 116, 255, 0.02), rgba(0, 209, 255, 0.015))"
                           />
                           
                           {/* <div className="contact__form">
                              <form >
                                 <input type="text" required placeholder="Your Name" />
                                 <input type="email" required placeholder="Your Email" />
                                 <textarea required placeholder="Your Message"></textarea>
                                 <button type="submit" className="z-btn">Send Message</button>
                              </form>
                           </div> */}

                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default ContactArea;
